import { Component, Inject } from '@angular/core';
import { ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';

@Component({
  selector: 'thehubz-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  readonly version?: string;
  readonly appName: string;

  constructor(@Inject(ENVIRONMENT) readonly env: ClientEnvironment) {
    this.version = `${env.environment !== 'LIVE' ? env.environment : ''} ${env.appVersion}`;
    this.appName = env.appTitle || 'Serviceplan MAKEOS!';
  }
}
